/*
 This file is https://raw.githubusercontent.com/JonathanTreffler/canvas2image-2/master/canvas2image.js
 with stuff we don't need removed, and a tweak to allow you to get the image contents without
 actually saving it.
*/

/* eslint-disable */

// check if support sth.
const $support = (function() {
  const canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d');

  return {
    canvas: !!ctx,
    imageData: !!ctx.getImageData,
    dataURL: !!canvas.toDataURL,
    btoa: !!window.btoa,
  };
})();

const downloadMime = 'image/octet-stream';

function scaleCanvas(canvas, width, height) {
  const w = canvas.width;
  const h = canvas.height;
  if (width == undefined) {
    width = w;
  }
  if (height == undefined) {
    height = h;
  }

  const retCanvas = document.createElement('canvas');
  const retCtx = retCanvas.getContext('2d');
  retCanvas.width = width;
  retCanvas.height = height;
  retCtx.drawImage(canvas, 0, 0, w, h, 0, 0, width, height);
  return retCanvas;
}

function getDataURL(canvas, type, width, height) {
  canvas = scaleCanvas(canvas, width, height);
  return canvas.toDataURL(type);
}

function saveFile(strData, fileType, fileName = "download") {
  const saveLink = document.createElement('a');
  saveLink.download = `${fileName}.${fileType}`;
  saveLink.href = strData;
  saveLink.click();
}

function genImage(strData) {
  const img = document.createElement('img');
  img.src = strData;
  return img;
}

function fixType(type) {
  type = type.toLowerCase().replace(/jpg/i, 'jpeg');
  const r = type.match(/png|jpeg|bmp|gif/)[0];
  return `image/${r}`;
}

function encodeData(data) {
  if (!window.btoa) {
    throw 'btoa undefined';
  }
  let str = '';
  if (typeof data === 'string') {
    str = data;
  } else {
    for (let i = 0; i < data.length; i++) {
      str += String.fromCharCode(data[i]);
    }
  }

  return btoa(str);
}

function getImageData(canvas) {
  const w = canvas.width;
  const h = canvas.height;
  return canvas.getContext('2d').getImageData(0, 0, w, h);
}

function makeURI(strData, type) {
  return `data:${type};base64,${strData}`;
}

/**
 * saveAsImage
 * @param canvasElement
 * @param {String} image type
 * @param {Number} [optional] png width
 * @param {Number} [optional] png height
 */
const saveAsImage = function(canvas, width, height, fileType) {
  if ($support.canvas && $support.dataURL) {
    if (typeof canvas === 'string') {
      canvas = document.getElementById(canvas);
    }
    if (fileType == undefined) {
      fileType = 'png';
    }
    const type = fixType(fileType);
    const strData = getDataURL(canvas, type, width, height);
    saveFile(strData.replace(type, downloadMime), fileType);
  }
};

const convertToImage = function(canvas, width, height, type) {
  if ($support.canvas && $support.dataURL) {
    if (typeof canvas === 'string') {
      canvas = document.getElementById(canvas);
    }
    if (type == undefined) {
      type = 'png';
    }
    type = fixType(type);
    const strData = getDataURL(canvas, type, width, height);
    return genImage(strData);
  }
};

const getImageContents = (canvas, width, height, type) => {
  if ($support.canvas && $support.dataURL) {
    if (typeof canvas === 'string') {
      canvas = document.getElementById(canvas);
    }
    if (type == undefined) {
      type = 'png';
    }
    type = fixType(type);
    return getDataURL(canvas, type, width, height).split(';base64,')[1];
  }
};

export default {
  saveAsImage,
  saveAsPNG(canvas, width, height) {
    return saveAsImage(canvas, width, height, 'png');
  },
  convertToImage,
  convertToPNG(canvas, width, height) {
    return convertToImage(canvas, width, height, 'png');
  },
  getImageContents,
  getImageContentsPNG(canvas, width, height) {
    return getImageContents(canvas, width, height, 'png');
  }
};
